import React from 'react'

import { SegmentedControl, PullToRefresh, Toast } from 'antd-mobile'
import GoodsInfo from './goods-info/goods-info'
import Coupon from './coupon/coupon'
import { connect } from 'react-redux'
import ReactDOM from 'react-dom'
import './fill.less'
import {
  SET_COUPON_LIST,
  SET_IS_DISTRIBUTE,
  SET_USE_INTEGRAL,
  SET_COUPON_NO,
} from '@/action-types/shopping-car'
import {
  orderPrepareApi,
  couponFlushApi,
  balanceInfoApi,
  createOrderApi,
} from '@/api/shopping-car'
import { setHeader } from '@/util/set-header'
import { goodStorage } from '@/util/good-storage'
import { store } from '@/stores'
import { GOODS_SET_COUNT } from '@/action-types/goods'

const APullToRefresh: any = PullToRefresh
interface Props {
  depot_id: string
}

const mapStateToProps = (state: any) => {
  return {
    depot_id: state.depot.id,
    coupon_no: state.shoppingCar.coupon_no,
    is_distribute: state.shoppingCar.is_distribute,
    use_integral: state.shoppingCar.use_integral,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    setCouponListAction: (coupon_list: any) =>
      dispatch({ type: SET_COUPON_LIST, coupon_list }),
    setIsDistributeAction: (is_distribute: boolean) =>
      dispatch({ type: SET_IS_DISTRIBUTE, is_distribute }),
    setUseIntegralAction: (use_integral: boolean) =>
      dispatch({ type: SET_USE_INTEGRAL, use_integral }),
    setCouponNoAction: (coupon_no: any) =>
      dispatch({ type: SET_COUPON_NO, coupon_no }),
  }
}

@(connect(
  mapStateToProps,
  mapDispatchToProps,
) as any)
class Fill extends React.Component<any, any> {
  private depot_id: string
  private messageText: string = ''
  private buyinfo: any
  private type: string
  private checkin_id: string = '330391'
  ptr!: PullToRefresh
  constructor(props: any) {
    super(props)
    const { match } = this.props
    this.depot_id = match.params.depot_id
    this.type = match.params.type

    let bfStr: any = sessionStorage.getItem('buyinfo')
    this.buyinfo = JSON.parse(bfStr)
    this.state = {
      refreshing: false,
      info: {},
      //is_transport 是否入住门店
      is_transport: false,
      notice: '',
      depot: {},
      goods_count: 0,
      goods_covers: [],
      goods_list: [],
      coupon_info: {},
      balanceInfo: {},
      receiver: {},
      viewAddress: {},
      height: document.documentElement.clientHeight - 90,
    }
      // 获取app中checkin_id
      window.setPaymentInfo = (argument: any) => {
        if (typeof(argument) === 'string') {
          this.checkin_id = JSON.parse(argument).checkin_id
        } else {
          this.checkin_id = argument['checkin_id']
        }
      }
      if (window.WebViewBridge) {
        window.WebViewBridge?.userInfo?.call(window.WebViewBridge, 'setPaymentInfo')
      } else if (window.webkit) {
        window.webkit.messageHandlers.userInfo.postMessage('setPaymentInfo')
      }
  }
  leftClick = () => {
    const { history } = this.props
    if (this.type === 'new') {
      history.goBack()
    } else {
      history.push(`/order-list/${this.type}`)
    }
  }
  UNSAFE_componentWillMount() {
    setHeader({ title: '填写订单', leftClick: this.leftClick })
    this.initBalanceInfo = this.initBalanceInfo.bind(this)
  }

  componentDidMount() {
    if (this.depot_id) {
      this.initData()
    }
    const height =
      document.documentElement.clientHeight -
      (ReactDOM.findDOMNode(this.ptr) as any).offsetTop -
      (document.querySelector('.navbar-bot') as any).clientHeight
    this.setState({ height })
  }
  initData = async () => {
    Toast.loading('加载中', 0)
    await Promise.all([
      this.prepare(),
      this.couponFlush(),
      this.initBalanceInfo(),
    ])

    Toast.hide()
  }
  onRefresh = async () => {
    Toast.loading('加载中', 0)
    await Promise.all([
      this.prepare(),
      this.couponFlush(),
      this.initBalanceInfo(),
    ])
    Toast.hide()
    this.setState({ refreshing: false })
  }
  //准备订单
  prepare = async () => {
    let buyinfo: any = sessionStorage.getItem('buyinfo')
    let params = {
      buyinfo: JSON.parse(buyinfo),
      depot_id: this.depot_id,
      fresh: false,
    }
    const { data } = await orderPrepareApi(params, this.type)
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    let {
      is_transport,
      notice,
      depot,
      goods_count,
      goods_covers,
      goods_list,
      receiver,
    } = data.data
    const { is_distribute } = this.props
    let viewAddress = {}
    if (is_distribute) {
      viewAddress = {
        name: receiver[0].full_name,
        tel: receiver[0].phone,
        address: receiver[0].text,
      }
    } else {
      viewAddress = {
        name: depot.name,
        tel: depot.contact_way,
        address: depot.address,
      }
    }
    this.setState({
      is_transport,
      notice,
      depot,
      goods_count,
      goods_covers,
      goods_list,
      receiver,
      viewAddress,
    })
  }
  //更新用户优惠券状态
  couponFlush = async () => {
    const { is_distribute } = this.props
    let params = {
      buyinfo: this.buyinfo,
      depot_id: this.depot_id,
      transport: is_distribute,
    }
    const { data } = await couponFlushApi(params, this.type)
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    this.setState({
      coupon_info: data.data,
    })
    const { setCouponListAction } = this.props
    const { coupon_list } = data.data
    setCouponListAction(coupon_list)
  }
  //订单价格信息
  async initBalanceInfo() {
    const { is_distribute, use_integral } = this.props
    let params: any = {
      buyinfo: this.buyinfo,
      depot_id: this.depot_id,
      use_integral: use_integral,
      is_distribute: is_distribute,
    }

    const { coupon_no } = this.props
    if (coupon_no) {
      params['coupon_no'] = coupon_no
    }
    const { data } = await balanceInfoApi(params, this.type)
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    this.setState({
      balanceInfo: data.data,
    })
  }

  //留言
  messageChange = (e: any) => {
    this.messageText = e
  }
  distributeChange = async (e: any) => {
    const { depot, receiver } = this.state
    const { setIsDistributeAction } = this.props
    if (e.nativeEvent.selectedSegmentIndex) {
      this.setState({
        viewAddress: {
          name: receiver[0].full_name,
          tel: receiver[0].phone,
          address: receiver[0].text,
        },
      })
      await setIsDistributeAction(true)
    } else {
      this.setState({
        viewAddress: {
          name: depot.name,
          tel: depot.contact_way,
          address: depot.address,
        },
      })
      await setIsDistributeAction(false)
    }
    Toast.loading('加载中', 0)
    await Promise.all([this.couponFlush(), this.initBalanceInfo()])
    Toast.hide()
  }
  //积分兑换
  integralChange = async () => {
    const { initBalanceInfo } = this
    const { setUseIntegralAction, use_integral } = this.props
    Toast.loading('加载中', 0)
    await setUseIntegralAction(!use_integral)
    await initBalanceInfo()
    Toast.hide()
  }
  //创建订单
  createOrder = async () => {
    const { buyinfo } = this
    const { coupon_no, use_integral, is_distribute, history } = this.props
    let params: any = {
      coupon_no: coupon_no,
      depot_id: this.depot_id,
      remark: this.messageText,
      buyinfo: this.buyinfo,
      use_integral: use_integral,
    }
    //是否配送
    if (is_distribute) {
      //checkin_id 房间号
      params['checkin_id'] = this.checkin_id
    }
    Toast.loading('加载中', 0)
    const { data } = await createOrderApi(params, this.type)

    // TODO: 清理支付中的goods数量
    let count = buyinfo.reduce((count: number, { goods_id, num }: { goods_id: string, num: number }) => {
      const good = goodStorage.dataBlobs.get(goods_id)
      if (good) {
        goodStorage.dataBlobs.set(goods_id, { ...good, buy_count: 0 })
      }
      return count + num
    }, 0)
    count = store.getState().goods.count - count
    if (count < 0) {
      count = 0
    }
    store.dispatch({
      type: GOODS_SET_COUNT,
      count
    })

    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    this.resetCoupnNo()
    if (window.WebViewBridge?.eventLabel) {
      window.WebViewBridge?.eventLabel('click_Order_pay', '')
    } else if (window.webkit) {
      window.webkit.messageHandlers.eventLabel.postMessage({'id': 'click_Order_pay'})
    }
    
    if (data.data.jump.jump_type === 'simple_detail') {
      if (this.type === 'new') {
        history.replace(`/fillorder/pay/${data.data.order_sn}/store`)
      } else {
        history.replace(`/fillorder/pay/${data.data.order_sn}/list`)
      }
    } else {
      this.props.history.replace(`/order-list/0`)
    }
  }
  //优惠券重置
  resetCoupnNo = async () => {
    const { setCouponNoAction } = this.props
    await setCouponNoAction('')
  }

  render() {
    const { is_distribute, use_integral, coupon_no } = this.props
    const is_show_notice = !this.state.is_transport || is_distribute

    return (
      <div className="fill-order">
        <APullToRefresh
          refreshing={this.state.refreshing}
          onRefresh={this.onRefresh}
          ref={(el: any) => (this.ptr = el)}
          style={{
            height: this.state.height,
            overflow: 'auto',
          }}
        >
          <div className="detail">
            <div className="header">
              {is_show_notice && (
                <span className="tips font_gray font-8">
                  {this.state.notice}
                </span>
              )}

              <SegmentedControl
                values={['门店自提', '配送上门']}
                tintColor={'#E74717'}
                onChange={this.distributeChange}
                selectedIndex={is_distribute ? 1 : 0}
                disabled={!this.state.is_transport}
                style={{ height: '0.35rem', width: '44%', color: '#E74717' }}
              />
              <div className="store">
                <span className="text-ell">
                  {is_distribute ? (
                    <img
                      src="/public/assets/img/delivery.png"
                      alt="font_gray"
                    />
                  ) : (
                      <i className="iconfont font_gray">&#xe60f;</i>
                    )}
                  &nbsp;{this.state.viewAddress.name}
                </span>
                <p className="font_gray"> {this.state.viewAddress.tel}</p>
                <p className="font_gray  txt_ell2">
                  {this.state.viewAddress.address}
                </p>
              </div>
            </div>

            <GoodsInfo
              goods_count={this.state.goods_count}
              goods_covers={this.state.goods_covers}
              messageChange={this.messageChange}
            />
            <Coupon
              coupon_info={this.state.coupon_info}
              coupon_no={coupon_no}
              use_integral={use_integral}
              integralChange={this.integralChange}
              balanceInfo={this.state.balanceInfo}
              is_distribute={is_distribute}
              depot_id={this.depot_id}
              type={this.type}
            />
          </div>
        </APullToRefresh>
        <div className="navbar-bot">
          付款
          <span className="font_yellow">
            &nbsp;￥{this.state.balanceInfo.pay_fee}
          </span>
          <div onClick={() => this.createOrder()} className="but-settl">
            去支付 <i className="iconfont font-5">&#xe60e;</i>
          </div>
        </div>
      </div>
    )
  }
}
export default Fill
